import { render, staticRenderFns } from "./FaceResult.vue?vue&type=template&id=396e9495&scoped=true&"
import script from "./FaceResult.vue?vue&type=script&lang=ts&"
export * from "./FaceResult.vue?vue&type=script&lang=ts&"
import style0 from "./FaceResult.vue?vue&type=style&index=0&id=396e9495&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396e9495",
  null
  
)

export default component.exports